import * as React from "react";
import FacebookLogin from "react-facebook-login";
import {
  Typography,
  TextField,
  Button,
  Card,
  Tooltip,
} from "@material-ui/core";
import Axios from "axios";
import { FacebookProvider, EmbeddedPost, Login } from "react-facebook";
import { GlobalState } from "src/store";
import * as actions from "../../store/facebook/actions";
import { connect } from "react-redux";
import { DubitoSvc } from "src/api";
import * as moment from "moment";

interface Props {
  url: string;
  expiresAt: number;
  setFacebookToken: (token: string, expiresAt: number) => void;
}
interface State {}
class Virality extends React.Component<Props, State> {
  state = {
    logined: false,
    userInfo: undefined,
    engagement: undefined,
    refresh: false,
    connectRequired: false,
  };
  onFacebookResponse = (userInfo) => {
    this.setState({ logined: true, userInfo: userInfo });

    DubitoSvc.facebookLogin({
      social_id: userInfo.profile.id,
      token: userInfo.tokenDetail.accessToken,
    }).then(() => {
      this.getLogins();
    });
  };
  getLogins() {
    DubitoSvc.getSocialLogins().then((res) => {
      const logins = {};
      if (res.facebook) {
        logins["facebook"] = res.facebook.expire_at;
        this.props.setFacebookToken("", moment(res.facebook.expire_at).unix());
      }
      this.checkURL(this.props.url);
      this.setState({ logins, connectRequired: false });
    });
  }
  checkURL = (url) => {
    DubitoSvc.getUrlVirality(url).then((res) => {
      //console.log(res);
      if (res.err && res.err.facebookLoginRequired) {
        this.setState({ connectRequired: true });
        return;
      }
      if (res.res) {
        this.setState({
          engagement: res.res.latest,
          connectRequired: false,
        });
        const history = [
          { ...res.res.latest, createdAt: moment().toISOString() },
        ];
        this.prepareGraph(history.concat(res.res.history));
      } else if (res.err.history) {
        this.setState({
          engagement: res.err.history[0],
        });
        this.prepareGraph(res.err.history);
      }
    });
  };
  prepareGraph(history: any[]) {
    /*  const timeRange = moment(history[0].createdAt).diff(
      moment(history[history.length - 1].createdAt)
    ); */
    if (!history || history.length <= 1) {
      return;
    }
    const lastIndex = history.length - 1;
    // if (timeRange < 24 * 60 * 1000) {
    // Show Day
    const data = [
      /*  { name: "12:00", engagement: 100 },
        { name: "18:00", engagement: 100 }, */
      {
        name: moment(history[lastIndex].createdAt).format("DD MMM YY HH:mm"),
        engagement:
          history[lastIndex].comments +
          history[lastIndex].share +
          history[lastIndex].reactions,
      },
      {
        name: moment(history[0].createdAt).format("DD MMM YY HH:mm"),
        engagement:
          history[0].comments + history[0].share + history[0].reactions,
      },
    ];
    this.setState({ history: data });
    //  }
  }
  componentDidMount() {
    //  if (this.props.expiresAt > new Date().getTime()) {
    this.checkURL(this.props.url);
    //  }
  }
  componentWillReceiveProps(next) {
    if (
      (next.expiresAt !== this.props.expiresAt &&
        next.expiresAt * 1000 > new Date().getTime()) ||
      next.url !== this.props.url
    ) {
      this.checkURL(next.url);
    }
  }
  renderConnectRequired() {
    if (this.state.connectRequired) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            style={{ height: 24, marginRight: 4 }}
            src={require("../../assets/facebook-icon.svg")}
          />
          <Typography style={{ color: "gray", marginRight: 4, flex: 1 }}>
            Would you like to connect your facebook account to see facebook
            impressions?
          </Typography>
          <FacebookProvider appId="213471075795721">
            {/*     <LoginButton scope="email" onCompleted={this.onFacebookResponse}>
                <Button>Login via Facebook</Button>
              </LoginButton> */}

            <Login scope="email" onCompleted={this.onFacebookResponse}>
              {({ loading, handleClick, error, data }) => (
                <Button variant="outlined" onClick={handleClick}>
                  <Typography>Connect</Typography>
                </Button>
              )}
            </Login>

            {/* this.state.logins.facebook && (
                <Typography variant="caption" style={{ marginTop: 12 }}>
                  Expires {moment(this.state.logins.facebook).fromNow()}.
                </Typography>
              ) */}
          </FacebookProvider>
        </div>
      );
    }
    return null;
  }
  renderEngagement = () => {
    if (this.state.engagement) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <Tooltip title="Total Impression">
              <div style={styles.engagementTuple}>
                <img
                  style={styles.engagementIcon}
                  src={require("../../assets/facebook-icon.svg")}
                />
                <Typography style={styles.engagementData}>
                  {numberWithCommas(
                    this.state.engagement!.reactions +
                      this.state.engagement!.comments +
                      this.state.engagement!.share
                  )}
                </Typography>
              </div>
            </Tooltip>
            <Tooltip title="Reaction Count">
              <div style={styles.engagementTuple}>
                <img
                  style={styles.engagementIcon}
                  src={require("../../assets/reactions-icon.svg")}
                />
                <Typography style={styles.engagementData}>
                  {numberWithCommas(this.state.engagement.reactions)}
                </Typography>
              </div>
            </Tooltip>
            <Tooltip title="Comment Count">
              <div style={styles.engagementTuple}>
                <img
                  style={styles.engagementIcon}
                  src={require("../../assets/comment-icon.svg")}
                />
                <Typography style={styles.engagementData}>
                  {numberWithCommas(this.state.engagement.comments)}
                </Typography>
              </div>
            </Tooltip>
            <Tooltip title="Share Count">
              <div style={styles.engagementTuple}>
                <img
                  style={styles.engagementIcon}
                  src={require("../../assets/share-icon.svg")}
                />
                <Typography style={styles.engagementData}>
                  {numberWithCommas(this.state.engagement.share)}
                </Typography>
              </div>
            </Tooltip>
          </div>
          <Typography
            variant="caption"
            style={{
              fontSize: 10,
              marginTop: 8,
              textAlign: "center",
              maxLines: 2,
            }}
          >
            Current Facebook impression data of URL
          </Typography>
        </div>
      );
    }
  };
  render() {
    return (
      <Card
        style={{
          padding: 16,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {this.renderConnectRequired()}
        {/* this.renderLogin() */}
        {this.renderEngagement()}
      </Card>
    );
  }
}
const styles = {
  engagementData: { minWidth: 30 },
  loadingEngagementData: {
    minWidth: 30,
    color: "lightgray",
    backgroundColor: "lightgray",
  },
  engagementIcon: { height: 24, marginRight: 4 },
  engagementTuple: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  } as any,
};
function numberWithCommas(x: any) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const FacebookVirality = connect(
  (state: GlobalState, own: any) => ({
    expiresAt: state.facebook.expiresAt,
  }),
  (dispatch) => ({
    setFacebookToken: (token: string, expiresAt: number): any =>
      dispatch(actions.updateToken(token, expiresAt)),
  })
)(Virality);



// WEBPACK FOOTER //
// ./src/pages/tools/facebookVirality.tsx